import * as React from 'react';
import { getSEPorts } from 'src/api/shipmentExecution';
import { useFieldProps } from 'src/hooks/form/useField';
import { useSelect, useStaticSelect } from 'src/hooks/form/useSelect';
import useApi from '../useApi';

const useSEPorts = (props: useFieldProps<{ shipmentExecutionId: string; fieldId: string }>) => {
  const { shipmentExecutionId: id, fieldId } = props.extraData || {};
  const ports = useApi(getSEPorts);
  const field = useSelect(
    props,
    getSEPorts,
    (data) => data?.map(dataMap) || [],
    (queryString) => ({ queryString, id, fieldId })
  );

  React.useEffect(() => {
    if (ports.status === 'FINISHED') {
      field.setOptions(ports.data?.map(dataMap) || []);
    }
  }, [ports.status]);

  /**
   * ISS-292713 — read-only parent-task PREVIEW port fields (shown at the top of a child task) don't get a
   * form value, so `field.value` is empty and the port-search never ran, leaving the port CODE unresolved
   * ("-"). Fall back to the field's own stored value so the name resolves in the preview/read context too.
   */
  const storedValue = (props.extraData as { values?: string[] })?.values?.[0];
  React.useEffect(() => {
    const query = field.value || storedValue;
    if (query) ports.call({ queryString: query, id, fieldId });
  }, [field.value, storedValue]);

  const dataMap = (item) => ({
    key: item.code,
    label: item.name,
    ...item,
  });

  return field;
};

export default useSEPorts;
